import React from 'react'
import classnames from 'classnames'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {
  Form,
  Dropdown,
  ComponentSize,
  ComponentColor,
} from '@influxdata/clockface'

import RegionTitle from './RegionTitle'

import {RegionInfo, State} from 'js/types'
import {updateRegionInfo} from './actions'
import {getRegionInfo, getRegions} from './selectors'
import {REQUEST_REGION_LINK} from './constants'

interface PassedProps {
  onChange?: any
  dropdownWidth?: number
  hideLabel?: boolean
}

interface StateProps {
  selectedRegionInfo: RegionInfo
  regions: RegionInfo[]
}

interface DispatchProps {
  onSelectRegion: typeof updateRegionInfo
}

type Props = StateProps & DispatchProps & PassedProps

const MarketplaceRegionPanelContents = ({
  selectedRegionInfo,
  regions,
  onSelectRegion,
  onChange,
  dropdownWidth,
}: Props): JSX.Element => {
  const style = dropdownWidth ? {width: `${dropdownWidth}px`} : {}
  return (
    <>
      <input
        name="region"
        type="hidden"
        value={selectedRegionInfo.region}
        data-testid="marketplace-splash--region"
      />
      <Form.Element label="">
        <Dropdown
          testID="region-dropdown"
          style={style}
          button={(active, onClick) => (
            <Dropdown.Button
              size={ComponentSize.Medium}
              active={active}
              onClick={onClick}
              color={ComponentColor.Primary}
            >
              <RegionTitle {...selectedRegionInfo} />
            </Dropdown.Button>
          )}
          menu={(onCollapse) => (
            <Dropdown.Menu onCollapse={onCollapse}>
              {regions.map((regionInfo) => {
                const className = classnames('region--dropdown-item', {
                  disabled: !regionInfo.isAvailable,
                })
                return (
                  <Dropdown.Item
                    testID={regionInfo.title}
                    id={regionInfo.title}
                    key={regionInfo.title}
                    value={regionInfo}
                    onClick={(info) => {
                      onSelectRegion(info)
                      /* eslint-disable @typescript-eslint/no-unused-expressions */
                      onChange && onChange(selectedRegionInfo, info)
                    }}
                    className={className}
                  >
                    <RegionTitle {...regionInfo} />
                  </Dropdown.Item>
                )
              })}
            </Dropdown.Menu>
          )}
        />
      </Form.Element>
      <p>
        Don't see the region you need?{' '}
        <a href={REQUEST_REGION_LINK} target="_blank">
          Let us know
        </a>
        .
      </p>
    </>
  )
}

const mstp = (state: State): StateProps => ({
  selectedRegionInfo: getRegionInfo(state),
  regions: getRegions(state),
})

const mdtp = (dispatch): DispatchProps =>
  bindActionCreators(
    {
      onSelectRegion: updateRegionInfo,
    },
    dispatch
  )

export default connect(mstp, mdtp)(MarketplaceRegionPanelContents)
